import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import {
  getUserRole,
  getCurrentAccount,
  handleRedirectResponse,
} from "./azure-auth";

import LandingPage from "./components/LandingPage";
import LandingPageCategories from "./components/LandingPageCategories";
import LandingPagePricing from "./components/LandingPagePricing";
import LandingPageAbout from "./components/LandingPageAbout";
import LandingPageContact from "./components/LandingPageContact";
import AuthAgentChat from './components/AuthAgentChat';
import PreLogin from "./components/PreLogin";
import Login from "./auth/Login";
import Dashboard from "./components/Dashboard";
import PublicDashboard from "./components/PublicDashboard";
import AdminDashboard from "./components/AdminDashboard";
import TestAisleWeb from "./components/test-aisle-web";
import DigitalLab from "./components/digital-lab";
import Embryo from "./components/embryo";
import ChatbotAMale from "./components/test-aisle-web-male";
import ChatbotAFemale from "./components/test-aisle-web-female";
import Sltmnit from "./components/sltmnit";
import InnoAssist from "./components/innospace-assistant-nonAuth";
import InternshipPlace from "./components/internship-placement-nonAuth";
import AskHr from "./components/askhr";
import AskEnterprise from "./components/ask-enterprise";
import InifiniAi from "./components/infiniai-nonAuth";
import EKB from "./components/ekb-agent";
import Privacy from "./components/Privacy";
import Terms from "./components/Terms";


const App = () => {
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [roleLoaded, setRoleLoaded] = useState(false);

  const handleAuthStateChange = async (account) => {
    if (account) {
      setUser(account);
      setRoleLoaded(false);
      try {
        const role = await getUserRole();
        setUserRole(role || "user");
        setRoleLoaded(true);
      } catch (error) {
        console.error("Error fetching user role:", error);
        setUserRole("user");
        setRoleLoaded(true);
      }
    } else {
      setUser(null);
      setUserRole(null);
      setRoleLoaded(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    const initializeAuth = async () => {
      await handleRedirectResponse();
      const account = getCurrentAccount();
      await handleAuthStateChange(account);
    };
    initializeAuth();
  }, []);

  useEffect(() => {
    const handleLoginEvent = async () => {
      const account = getCurrentAccount();
      await handleAuthStateChange(account);
    };
    const handleLogoutEvent = async () => {
      setUser(null);
      setUserRole(null);
      setRoleLoaded(false);
      setLoading(false);
    };
    window.addEventListener("userLogin", handleLoginEvent);
    window.addEventListener("userLogout", handleLogoutEvent);
    return () => {
      window.removeEventListener("userLogin", handleLoginEvent);
      window.removeEventListener("userLogout", handleLogoutEvent);
    };
  }, []);

  if (loading || (user && !roleLoaded)) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", color: "white" }}>
        Loading...
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/sltmnit" element={<Sltmnit />} />
        <Route path="/prelogin" element={<PreLogin />} />
        <Route path="/categories" element={<LandingPageCategories />} />
        <Route path="/pricing" element={<LandingPagePricing />} />
        <Route path="/about" element={<LandingPageAbout />} />
        <Route path="/contact" element={<LandingPageContact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/public-dashboard" element={<PublicDashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/innospace-assistant-nonAuth" element={<InnoAssist />} />
        <Route path="/internship-placement-nonAuth" element={<InternshipPlace />} />
        <Route path="/infiniai-nonAuth" element={<InifiniAi />} />
        <Route path="/ekb-agent" element={<EKB />} />
        <Route path ="/askhr-nonAuth" element={<AskHr />} />
     

        {user && roleLoaded ? (
          <>
            <Route path="/dashboard" element={<Dashboard userRole={userRole} />} />
            {userRole === "admin" && (
              <Route path="/admin-dashboard" element={<AdminDashboard />} />
            )}
            <Route path="/test-aisle-web" element={<TestAisleWeb />} />
            <Route path="/test-aisle-web-male" element={<ChatbotAMale />} />
            <Route path="/test-aisle-web-female" element={<ChatbotAFemale />} />
            <Route path="/askhr" element={<AuthAgentChat agentKey="askhr" agentName="Ask HR" />} />
            <Route path="/digital-lab" element={<DigitalLab />} />
            <Route path="/embryo" element={<Embryo />} />
            <Route path="/ask-enterprise" element={<AskEnterprise />} />
            <Route path="/ask-finance" element={<AuthAgentChat agentKey="askfinance" agentName="Ask Finance" />} />
            <Route path="/ask-IT" element={<AuthAgentChat agentKey="askit" agentName="Ask IT" />} />
            <Route path="/ask-admin" element={<AuthAgentChat agentKey="askadmin" agentName="Ask Admin" />} />
            <Route path="/workmate-ai" element={<AuthAgentChat agentKey="workmate" agentName="WorkMate AI" />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
            <Route path="/ask-finance-copilot" element={<AuthAgentChat agentKey="askfinance_copilot" agentName="Ask Finance" />} />
          </>
        ) : (
          <Route path="*" element={<Navigate to="/" replace />} />
        )}
      </Routes>
    </Router>
  );
};

export default App;